module.exports = {
    "Empty": `\u{7A7A}`
};


//# sourceMappingURL=ja-JP.main.js.map
